/**
 * Icons, imported individually so the bundle carries only what is used.
 *
 * The 2020 app called `library.add()` on the entire free-solid and free-brands
 * sets in `setupFontAwesome.js` and referenced icons by string name, which
 * defeats tree-shaking — every icon shipped whether or not it appeared.
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowLeft,
  faChartLine,
  faCheck,
  faCircleUser,
  faEnvelope,
  faGear,
  faPlus,
  faRightFromBracket,
  faTrash,
  faTriangleExclamation,
  faUserShield,
} from "@fortawesome/free-solid-svg-icons";
import { faGithub, faSquareTwitter } from "@fortawesome/free-brands-svg-icons";

const ICONS = {
  back: faArrowLeft,
  chart: faChartLine,
  check: faCheck,
  envelope: faEnvelope,
  github: faGithub,
  plus: faPlus,
  settings: faGear,
  signOut: faRightFromBracket,
  trash: faTrash,
  twitter: faSquareTwitter,
  user: faCircleUser,
  userShield: faUserShield,
  warning: faTriangleExclamation,
} satisfies Record<string, IconDefinition>;

export type IconName = keyof typeof ICONS;

export function Icon({
  name,
  size,
  className,
}: {
  name: IconName;
  size?: "sm" | "lg" | "2x";
  className?: string;
}) {
  return <FontAwesomeIcon icon={ICONS[name]} size={size} className={className} />;
}
